<div class="company-overview" [ngClass]="{'z5': false}">
    <div class="company-header row align-items-center mx-0 pt-0 pb-1 pl-2">
		<span class="col-xs-auto ml-2 company-icon" i18n-title>
            <span class="material-icons text-light">business</span>
			<h3 class="my-0 ml-2 d-inline-block">{{company?.name}}</h3>
        </span>
        <div class="col d-none d-sm-block pl-2"></div>
        <div class="col-12 col-sm-auto mt-1 row mx-0">
            <span class="your-role pr-1" i18n>Your role:</span>
            <div *ngIf="isAdmin" class="col-xs-auto badge badge-pill badge-danger ml-1 pt-1 pb-1 px-3" i18n="short for administration">ADMIN</div>
        </div>
        <div *ngIf="isAdmin" class="col-12 col-sm-auto ml-0 text-right">
            <button id="companyOverviewMenu" type="button" mat-icon-button [matMenuTriggerFor]="companyMenu">
                <mat-icon class="material-icons">more_vert</mat-icon>
            </button>
            <mat-menu #companyMenu="matMenu" xPosition="before">
                <div class="top-right-drop-menu">
					<button id="companyOverviewMenuRefresh" mat-menu-item (click)="refreshCompany()">
                        <div class="row px-2">
                            <div class="col-xs-auto pt-2"><span class="material-icons">cached</span></div>
                            <div class="col pl-2"><span i18n="button title to refresh a company">Refresh</span></div>
                        </div>
					</button>
                </div>
            </mat-menu>
        </div>
    </div>

    <div class="row">

		<mat-tab-group
			class="col-12"
			dynamicHeight
			animationDuration="0ms"
			mat-stretch-tabs
			[selectedIndex]="selectedTab"
			(selectedIndexChange)="selectTab($event)"
		>
			<mat-tab i18n-label label="App Keys" [disabled]="!isAdmin">
				<ng-template matTabContent>
					<div class="col-12 mt-3">
						<app-keys-table [editable]="isAdmin" [company]="company"></app-keys-table>
					</div>
				</ng-template>
			</mat-tab>
			<mat-tab i18n-label label="Contacts" [disabled]="!isAdmin">
				<div  class="col-12 text-center">
					<ng-container>
						<div class="text-danger my-4" i18n><p>Permissions for Admin Portal are now provisioned by Employee SSO.</p><p>See <a href="api-documentation/admin-portal/#access-to-the-admin-portal">Admin Portal Documentation</a> for more information.</p></div>
					</ng-container>
				</div>
			</mat-tab>
			<mat-tab [disabled]="!isAdmin">
				<ng-template mat-tab-label>
					<span i18n>Legals</span>
				</ng-template>
				<ng-template matTabContent>
					<div class="row">
						<mat-accordion class="legals-accordion col-12" [attr.data-open]="openPanel">
							<mat-expansion-panel [expanded]="openPanel === 'company'" (opened)="openPanel = 'company'" (closed)="openPanel = 'service'">
								<mat-expansion-panel-header class="company-legals-accordion">
									<mat-panel-title>Company legals<mat-icon
										class="info-icon"
										aria-hidden="false"
										aria-label="icon displays a tooltip when focused or hovered over"
										matTooltip="Company terms of service documents, owned and managed by the company."
										i18n-matTooltip
									>info</mat-icon></mat-panel-title>
								</mat-expansion-panel-header>
								<app-legals-table-app
									[editable]="isAdmin"
									[company]="company"
								></app-legals-table-app>
							</mat-expansion-panel>
						</mat-accordion>
					</div>
				</ng-template>
			</mat-tab>
		</mat-tab-group>
    </div>
</div>
